import fetch from 'isomorphic-fetch';
import _ from 'lodash';

class FetchContext {

  static token() {
    let el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute('content') : '';
  }

}

export class Fetch extends FetchContext {

  static headers() {
    return {
      'Accept': 'text/html',
      'Content-Type': 'text/html',
      'X-CSRF-Token': this.token(),
      'X-Requested-With': 'XMLHttpRequest'
    }
  }

  static delete(route, params, follow = true) {
    return this.xhr(route, params, 'delete', follow);
  }

  static xhr(route, params, verb, follow = true) {
    return fetch(route, {
      method: verb,
      credentials: 'include',
      mode: 'cors',
      redirect: 'follow',
      headers: this.headers()
    })
      .then(response => {
        const loc = response.headers.get('location');
        if(!!loc && follow) {
          window.location = loc;
        }
    });
  }

}

export class Api extends FetchContext {

  static headers() {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': this.token(),
      'X-Requested-With': 'XMLHttpRequest'
    }
  }

  static uploadHeaders() {
    return {
      'Accept': 'application/json',
      'X-CSRF-Token': this.token(),
      'X-Requested-With': 'XMLHttpRequest'
    }
  }

  static delete(route, params) {
    return this.xhr(route, params, 'delete');
  }

  static get(route, params) {
    return this.xhr(route, params, 'get');
  }

  static put(route, params) {
    return this.xhr(route, params, 'put');
  }

  static post(route, params) {
    return this.xhr(route, params, 'post');
  }

  static handleErrors(response) {
    const defErr = "An unexpected error occurred."
    if (!response.ok) {
      if(response.status === 500) {
        throw Error(defErr);
      } else {
        return response.json().then( j => {
          let message = j['error'] || defErr;
          throw Error(message);
        }).catch( err => {
          if (err.name === 'SyntaxError') {
            throw Error(defErr);
          } else {
            throw err;
          }
        });
      }
    }
    return response;
  }

  static xhr(route, params, verb) {
    return fetch(route, _.merge({
      method: verb,
      credentials: 'include',
      headers: this.headers()
    }, { body: JSON.stringify(params) }))
      .catch(err => {
        throw Error("The Hub cannot be reached. Please try again momentarily.");
      })
      .then(this.handleErrors)
      .then( resp => {
      return resp.json();
    });
  }

  static upload(route, data) {
    return fetch(route, {
      method: 'post',
      credentials: 'include',
      headers: this.uploadHeaders(),
      body: data
    })
      .catch(err => {
        throw Error("The Hub cannot be reached. Please try again momentarily.");
      })
      .then(this.handleErrors)
      .then( resp => {
      return resp.json();
    });
  }

  static download(route) {
    return fetch(route, {
      method: 'get',
      credentials: 'include',
      headers: {
        'X-CSRF-Token': this.token(),
        'X-Requested-With': 'XMLHttpRequest'
      },

    });
  }
}
